(function () {
    'use strict';

    if ($('#location-search').length === 0) return;

    var timezone = require('../modules/Timezone');
    var moment = require('moment-timezone');

    var lat = 0;
    var long = 0;

    function updateLocation(location) {
        lat = location.coords.latitude;
        long = location.coords.longitude;

        $.ajax('/api/weather/' + lat + ',' + long).done(function (response) {
            $('#weather-container').empty();

            if (!response.success) {
                return;
            }

            getLocalTime(lat, long, function (time) {
                var data = response.data;

                $('#weather-container').html(
                    getElements(data.name, '', time, data.icon, data.temperature, data.wind, data.humidity)
                );

                $('.clock').FlipClock({
                    clockFace: 'TwentyFourHourClock',
                });
            });
        });
    }

    function updateLocationByName(country, location) {
        //location = location.split(' ')[0];
        location = location
            .replace('Green Motion', '')
            .replace('Airport', '')
            .replace('Downtown', '')
            .replace('servicing', '')
            .replace('Servicing', '')
            .replace('Aeropuerto', '')
            .replace('Centre', '')
            .replace('City', '')
            .replace('International', '');

        if (country === 'Republic of Ireland') {
            country = 'Ireland';
        }

        $.ajax('/api/weather/' + country + ',' + location).done(function (response) {
            $('#weather-container').empty();

            if (!response.success) {
                if (location.length > 0) return updateLocationByName(country, '');

                return;
            }

            var data = response.data;

            getLocalTime(data.latitude, data.longitude, function (time) {
                $('#weather-container').html(
                    getElements(country, location, time, data.icon, data.temperature, data.wind, data.humidity)
                );

                var splitTime = time.split(':');
                var seconds = +splitTime[0] * 60 * 60 + +splitTime[1] * 60 + +splitTime[2];

                $('.clock').FlipClock(seconds);
            });
        });
    }

    function getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(updateLocation);
        }
    }

    function getLocalTime(latitude, longitude, callback) {
        timezone.getTimezone(latitude, longitude, function (timezone) {
            var time = moment().tz(timezone.timeZoneId).format('HH:mm:ss');

            callback(time);
        });
    }

    function getElements(country, location, time, icon, temp, speed, humidity) {
        String.prototype.capitalize = function () {
            return this.replace(/(?:^|\s)\S/g, function (a) {
                return a.toUpperCase();
            });
        };

        var elements =
            '<div class="row weather-info">' +
            '<ul>' +
            '   <li class="weather-location">' +
            country.capitalize() +
            '<span>' +
            location.capitalize() +
            '</span></li>' +
            '   <li class="weather-time"><span>' +
            gmtrans('home.weather.local_time_label') +
            ' </span><div class="clock"></div></li>' +
            '   <li class="weather-icon"><img src="/images/weather-icons/' +
            icon +
            '.png" alt=""/></li>' +
            '   <li class="weather-temperature">' +
            Math.round(temp) +
            '<img src="/images/weather-icons/temp-celsius.png" alt="" /></li>' +
            '   <li class="weather-wind-speed">' +
            speed +
            ' m/s <span>' +
            gmtrans('home.weather.windspeed_label') +
            '</span></li>' +
            '   <li class="weather-humidity">' +
            humidity +
            ' %<span>' +
            gmtrans('home.weather.humidity_label') +
            '</span></li>' +
            '</ul>' +
            '</div>';

        return elements;
    }

    $('#location-search')[0].selectize.on('change', function (value) {
        var country = $($('.option.selected')[0]).text();
        var location = $($('.option.selected')[1]).text();

        if (country && location && value) {
            updateLocationByName(country, location);
        }
    });

    getLocation();
})();
